<div class="flex flex-column h-full">
  <div class="flex align-items-center gap-2 mb-2">
    <div class="flex flex-wrap gap-2" *ngIf="userType.could_manage_contents">
      <p-inputSwitch
        [(ngModel)]="inactives"
        (ngModelChange)="onInactivesChange()"
      ></p-inputSwitch>
      <span class="relative" style="top: -1px">Inactivos</span>
    </div>
    <div class="flex-grow-1 flex justify-content-end">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-file-export"
        class="p-button-danger me-3 position-relative mr-2"
        (click)="generateTablePdf()"
      ></button>
      <button
        pButton
        pTooltip="Resetear filtros"
        tooltipPosition="bottom"
        icon="pi pi-filter-slash"
        class="p-button-warning ml-2 mr-4"
        (click)="resetDTFilters()"
      ></button>
      <app-prime-ng-export-table
        [primeNgList]="this"
      ></app-prime-ng-export-table>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-table"
        label="{{ 'FORM.SHOW-HIDE-COLUMNS' | translate }}"
        class="p-button-success me-3 position-relative"
        (click)="openColumnSidebar()"
      ></button>
    </div>
  </div>
  <div class="text-sm font-bold text-danger mb-2" *ngIf="inactives">
    Visualizando inactivos
  </div>
  <div class="flex-grow overflow-hidden h-full">
    <p-table
      [columns]="columns"
      [dataKey]="keys.primary_key"
      [value]="rows"
      [loading]="loading"
      [paginator]="true"
      [rows]="rowsPerPage"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      styleClass="p-datatable-gridlines"
      [(selection)]="selectedRows"
      [scrollable]="true"
      scrollHeight="flex"
      [resizableColumns]="true"
      [currentPageReportTemplate]="
        'GENERAL.SHOWING-X-TO-Y-OF-Z-ROWS'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      "
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3rem" pFrozenColumn>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of columns">
            <th
              [pSortableColumn]="col.sortable"
              pFrozenColumn
              [frozen]="col.frozen"
              pResizableColumn
              [pResizableColumnDisabled]="!col.resizable"
              [width]="col.width"
              [style.minWidth.px]="col.resizable ? 0 : col.width"
              *ngIf="col.visible"
            >
              <div class="flex align-items-center gap-2">
                {{ col.header | translate }}
                <p-sortIcon
                  *ngIf="col.sortable"
                  [field]="col.sortable"
                ></p-sortIcon>
                <div [ngSwitch]="col.field" *ngIf="col.filterable">
                  <div *ngSwitchCase="'tags'">
                    <app-filter-comma-separated
                      [field]="'tags'"
                      [matchModeOptions]="matchModeOptions"
                      [data]="rows"
                    >
                    </app-filter-comma-separated>
                  </div>
                  <div *ngSwitchCase="'type_'">
                    <app-filter-content-type
                      [field]="'type_'"
                      [matchModeOptions]="matchModeOptions"
                      [data]="rows"
                    >
                    </app-filter-content-type>
                  </div>
                  <div *ngSwitchDefault>
                    <p-columnFilter
                      type="text"
                      [field]="col.sortable"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          </ng-container>
          <th [width]="150" alignFrozen="right" pFrozenColumn></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td pFrozenColumn>
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns">
            <td
              pFrozenColumn
              [frozen]="col.frozen"
              [width]="col.width"
              *ngIf="col.visible"
            >
              <ng-container [ngSwitch]="col.field">
                <div
                  *ngSwitchCase="'type_'"
                  class="text-center"
                  style="white-space: pre-line"
                >
                  <span
                    class="material-symbols-outlined"
                    style="font-size: 2rem"
                    [pTooltip]="
                      globals.CONTENT_TYPES[row.type_].label | translate
                    "
                  >
                    {{ globals.CONTENT_TYPES[row.type_].materialIcon }}
                  </span>
                </div>
                <div *ngSwitchDefault style="white-space: pre-line">
                  {{ col.field | ngCellValue : row }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <td [width]="150" class="p-2" alignFrozen="right" pFrozenColumn>
            <div
              class="flex flex-grow-1 justify-content-center md:justify-content-end mt-2 md:mt-0 gap-2"
            >
              <app-content-trigger-button
                [item]="row"
              ></app-content-trigger-button>
              <ng-container *ngIf="userType.could_manage_contents">
                <button
                  pButton
                  pRipple
                  icon="pi pi-pencil"
                  pTooltip="{{ 'ENV.EDIT' | translate }}"
                  (click)="edit(row, true)"
                  class="p-button-text p-button-raised"
                ></button>
                <button
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  pTooltip="{{ 'ENV.DELETE' | translate }}"
                  (click)="inactivate(row)"
                  class="p-button-text p-button-raised p-button-danger"
                  *ngIf="row.status_ === 1"
                ></button>
                <button
                  pButton
                  pRipple
                  icon="pi pi-upload"
                  pTooltip="{{ 'ENV.REACTIVATE' | translate }}"
                  (click)="reactivate(row)"
                  class="p-button-text p-button-raised p-button-success"
                  *ngIf="row.status_ === 0"
                ></button>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">{{ "WIDGET.DT-EMPTY" | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="isColumnToggleVisible"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: '100%', 'max-width': '20em' }"
>
  <app-prime-list-columns-toggle
    [(columns)]="columns"
  ></app-prime-list-columns-toggle>
</p-sidebar>

<p-dialog
  header="{{ 'MENU.REPORTS' | translate }}"
  [(visible)]="isPdfTableDialogVisible"
  [modal]="true"
  [style]="{ width: '95%', height: '95%' }"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ height: '100%' }"
>
  <app-modal-table-pdf
    *ngIf="isPdfTableDialogVisible"
    [courseDetail]="courseDetail"
    [selectedDataColumns]="columns"
    [selectedDataTable]="rows"
  >
  </app-modal-table-pdf>
</p-dialog>
